<template>
  <div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true" style="overflow: hidden;">
    <div class="m-portlet m-portlet--mobile">
      <PageHead label='住培生分数汇总统计' :label2='this.title' url="/report/score/stu/list"></PageHead>
      <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
        <!--begin: Search Form -->
        <div class="m-form m-form--label-align-right">
          <div style="float: left;margin-top: 10px;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 100px;text-align:right;">考核月份：</label>
              </div>
              <div class="m-form__control">
                <el-date-picker v-model="condition.cpidate" type="month" placeholder="考核月份" value-format="yyyy-MM">
                </el-date-picker>
              </div>
            </div>
            <div class="d-md-none m--margin-bottom-10"></div>
          </div>
        </div>
        <div style="clear: both;"></div>
        <div class="m--margin-top-10 m--margin-bottom-10" style="width: 100%;text-align: center;">
          <SearchButton :url='searchUrl' ref="btnSearch"></SearchButton>
          <ExportButton :url='exportUrl' buttonname="导出"></ExportButton>
        </div>
        <!--end: Search Form -->
        <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
          <!--begin: Datatable -->
          <el-table :data="tableData" stripe style="width: 100%" size="medium" @row-click="CPIInfo">
            <el-table-column label="考核月份">
              <template slot-scope="scope">
                {{scope.row.CPIDate|formatDate}}
              </template>
            </el-table-column>
            <el-table-column prop="CPIDSecName" label="考核科室">
            </el-table-column>
            <el-table-column prop="CPIDScore" label="得分">
            </el-table-column>
          </el-table>
          <!--end: Datatable -->
          <div style="margin-top: 10px;text-align: center;" v-if="this.condition.recordCount > 0">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="condition.currentPage"
              :page-sizes="[2, 10, 20, 30, 40]" :page-size="condition.pageSize" layout="total, sizes, prev, pager, next, jumper"
              :total="condition.recordCount">
            </el-pagination>
          </div>
          <!--end: Datatable -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ScoreStuUser',
  data () {
    return {
      condition: {
        cpitype: '1',
        cpidate: '',
        id: '',
        name: '',
        token: '',
        pageSize: 10,
        currentPage: 1,
        recordCount: 0,
        firstSearch: true
      },
      title: '',
      tableData: null,
      searchUrl: this.$utils.Url.zpgl + '/api/APICPI/ReportScoreCPIList',
      exportUrl: this.$utils.Url.zpgl + '/api/APICPI/ReportScoreCPIListOut'
    }
  },
  filters: {
    formatDate (val) {
      var now = new Date(val)
      var y = now.getFullYear()
      var m = now.getMonth() + 1
      return y + '-' + (m < 10 ? '0' + m : m)
    }
  },
  methods: {
    // 调整每页显示数
    handleCurrentChange: function (val) {
        this.condition.firstSearch = false
      this.condition.currentPage = val
      this.$refs.btnSearch.Search()
    },
    // 分页操作
    handleSizeChange: function (val) {
        this.condition.firstSearch = false
      this.condition.pageSize = val
      this.condition.currentPage = 1
      this.$refs.btnSearch.Search()
    },
    CPIInfo: function (row) {
      var fd = this.$options.filters['formatDate']
      this.$router.push({name: 'ScoreStuScoreRecord', params: {id: row.CPIDID,secname: row.CPIDSecName, month: fd(row.CPIDate)}})
    }
  },
  mounted: function () {
    this.condition.token = sessionStorage.getItem('token')
    this.condition.id = this.$route.params.id
    this.condition.name = this.$route.params.name
    this.title = this.condition.name
    this.$refs.btnSearch.Search()
  }
}
</script>

<style>
</style>
